import { mockUserClientSubclientData } from "@/entities";
import { UserClient } from "./client";
import { IUserClient, IUserClientData } from "./client.types";

export const mockUserClientData = (): IUserClientData[] => [
  {
    id: 2,
    oidSol: "45a39a3d-c643-4d41-8e3a-69a377461bd8",
    codeSol: "5",
    idSmartcash: "4554",
    uniqueCode: "",
    description: "Banco Santander Rio Sociedad Anonima",
    active: true,
    subclients: [mockUserClientSubclientData()[0]],
  },
  {
    id: 7,
    oidSol: "3f86c723-c636-4357-a9bd-f2191adec776",
    codeSol: "8944",
    idSmartcash: "008944",
    uniqueCode: "",
    description: "Empresa De Distribucion Electrica De Tuc",
    active: true,
    subclients: [mockUserClientSubclientData()[1]],
  },
];

export const mockUserClient = (data: IUserClientData[] = mockUserClientData()): IUserClient[] =>
  data.map((item) => new UserClient(item));
